import { format } from 'date-fns';
import { cs } from 'date-fns/locale';

export const formatCs: typeof format = (date, returnFormat, options) =>
  format(date, returnFormat, { ...options, locale: cs });

export const formatCsMonth = (date: Date) =>
  formatCsMonthLongText(date).charAt(0).toUpperCase() +
  formatCsMonthLongText(date).slice(1);

export const formatCsDayWithNumber = (date: Date) =>
  `${formatCsDayShortText(date)} ${formatCsDayNumber(date)}`;

export const formatCsEventSummary = (date: Date) =>
  `${formatCsDayLongText(date)} ${formatCsDayNumber(
    date,
  )} ${formatCsMonthLongText(date)}, od ${formatCsHour(date)} h`;

export const formatCsDayShortText = (date: Date) => formatCs(date, 'EEEEEE');

export const formatCsDayLongText = (date: Date) => formatCs(date, 'EEEE');

export const formatCsMonthLongText = (date: Date) => formatCs(date, 'LLLL');

export const formatCsDayNumber = (date: Date) => formatCs(date, 'd.');

export const formatCsHour = (date: Date) => formatCs(date, 'H');
